

/// <reference path="StockNote.ts" />

// Generated class SupplierNote_ManagedObject

class SupplierNote_ManagedObject extends StockNote
{
}
